// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-btn {
  transition:
    background-color 0.3s,
    box-shadow 0.3s;

  padding: 5px 8px;
  border: none;
  border-radius: 8px;

  color: #757575;
  font-size: 14px;
  font-weight: 500;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;

  &:hover {
    box-shadow:
      0 -1px 0 rgba(255, 255, 255, 0.9),
      0 2px 4px rgba(255, 255, 255, 0.7);
    cursor: pointer;
  }

  &:active {
    background-color: #eeeeee;
  }

  &:focus {
    outline: none;
    box-shadow:
      0 -1px 0 rgba(0, 0, 0, 0.04),
      0 2px 4px rgba(0, 0, 0, 0.25),
      0 0 0 3px #c8dafc;
  }

  &:disabled {
    filter: grayscale(100%);
    background-color: #ebebeb;
    box-shadow:
      0 -1px 0 rgba(0, 0, 0, 0.04),
      0 1px 1px rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
  }
}

.menu-paper {
  background-color: #1e2643 !important;
}

.menu-text {
  color: white !important;
  font-size: 14;
}
/* these are the navbar , if you want to change color for the nav its ".nextui-navbar-container" */
.nextui-navbar-container {
  background: var(--ion-color-primary) !important;
}

.nextui-navbar-container {
  border-radius: 0;
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
  color: white !important;
  font-size: 14;
}

.usericon:hover {
  cursor: pointer;
}
.nextui-dropdown-item-content {
  font-weight: 600;
}

li[class*="is-focused dropdown-item"] {
  background-color: transparent !important;
}

.dropdown-item:hover {
  background-color: rgb(0, 86, 156) !important ;
}

.dropdown-item:hover > span {
  color: #FFFFFF !important;
}

/*only 3 importants, the control , the base color , the hover color , and the logout hover color */
`, "",{"version":3,"sources":["webpack://./src/components/Auth/styles.css"],"names":[],"mappings":"AAAA;EACE;;mBAEiB;;EAEjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;;EAElB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB;8EAC4E;;EAE5E;IACE;;wCAEoC;IACpC,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb;;;uBAGmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;IACzB;;mCAE+B;IAC/B,mBAAmB;EACrB;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;AACA,kGAAkG;AAClG;EACE,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kGAAkG","sourcesContent":[".auth-btn {\n  transition:\n    background-color 0.3s,\n    box-shadow 0.3s;\n\n  padding: 5px 8px;\n  border: none;\n  border-radius: 8px;\n\n  color: #757575;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,\n    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n\n  &:hover {\n    box-shadow:\n      0 -1px 0 rgba(255, 255, 255, 0.9),\n      0 2px 4px rgba(255, 255, 255, 0.7);\n    cursor: pointer;\n  }\n\n  &:active {\n    background-color: #eeeeee;\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow:\n      0 -1px 0 rgba(0, 0, 0, 0.04),\n      0 2px 4px rgba(0, 0, 0, 0.25),\n      0 0 0 3px #c8dafc;\n  }\n\n  &:disabled {\n    filter: grayscale(100%);\n    background-color: #ebebeb;\n    box-shadow:\n      0 -1px 0 rgba(0, 0, 0, 0.04),\n      0 1px 1px rgba(0, 0, 0, 0.25);\n    cursor: not-allowed;\n  }\n}\n\n.menu-paper {\n  background-color: #1e2643 !important;\n}\n\n.menu-text {\n  color: white !important;\n  font-size: 14;\n}\n/* these are the navbar , if you want to change color for the nav its \".nextui-navbar-container\" */\n.nextui-navbar-container {\n  background: var(--ion-color-primary) !important;\n}\n\n.nextui-navbar-container {\n  border-radius: 0;\n  border-bottom-right-radius: 1rem;\n  border-bottom-left-radius: 1rem;\n  color: white !important;\n  font-size: 14;\n}\n\n.usericon:hover {\n  cursor: pointer;\n}\n.nextui-dropdown-item-content {\n  font-weight: 600;\n}\n\nli[class*=\"is-focused dropdown-item\"] {\n  background-color: transparent !important;\n}\n\n.dropdown-item:hover {\n  background-color: rgb(0, 86, 156) !important ;\n}\n\n.dropdown-item:hover > span {\n  color: #FFFFFF !important;\n}\n\n/*only 3 importants, the control , the base color , the hover color , and the logout hover color */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
